import { useGo } from '../../app/navigation';
import { setSetting, useSettings } from '../../core/store';
import { shortNote } from '../../core/theory';
import { Btn } from '../../ui/Button';
import { VOICE_TYPES } from './voice';

/** Choose a voice type (sets the vocal range) or go to the range test (`test`: offer it, default true). */
export function VoicePicker({ onDone, test = true }: { onDone?: () => void; test?: boolean }) {
  const go = useGo();
  const settings = useSettings();
  return (
    <div className="range-card">
      <p>Egzersizler sesinin rahat bölgesine göre ayarlanır. Ses tipini seç ya da aralık testini yap.</p>
      <div className="voice-pick">
        {VOICE_TYPES.map((v) => (
          <button
            key={v.id}
            type="button"
            className={`vp-btn${settings.voiceType === v.id ? ' on' : ''}`}
            onClick={() => {
              setSetting('voiceType', v.id);
              setSetting('voiceLow', v.lo);
              setSetting('voiceHigh', v.hi);
              onDone?.();
            }}
          >
            <strong>{v.name}</strong>
            <small>
              {shortNote(v.lo)}–{shortNote(v.hi)}
            </small>
          </button>
        ))}
      </div>
      {test ? (
        <div>
          <Btn kind="ghost" icon="voice" onClick={() => go('vokal.aralik-testi')}>
            Aralık testini yap
          </Btn>
        </div>
      ) : null}
    </div>
  );
}
